<script setup lang="ts">
import { toRef, useDefaults } from '#imports'
import type { Defaults } from '@core/types'

export interface UIDefaultsProviderProps {
    defaults: Defaults
}
const props = defineProps<UIDefaultsProviderProps>()

useDefaults({
    props: toRef(props, 'defaults')
})
</script>

<template>
    <slot />
</template>
